import React from 'react';
import InnerBanner from '../components/InnerBanner';

const CookiePolicy = () => {
    return (
        <>
            <InnerBanner title="Cookie Policy" />
            <div className="policy-content">
                <div className="container">
                    <div className="inner-head">
                        <h2>Cookie Policy</h2>
                    </div>

                    {/* Introduction Section */}
                    <section className="cards">
                        <h3>Introduction</h3>
                        <p>
                            CloudifyDocs is committed to protecting your privacy. This Cookie Policy explains how and why we use cookies on our platform. By using our services, you consent to our use of cookies in accordance with this policy.
                        </p>
                    </section>

                    {/* What Are Cookies Section */}
                    <section className="cards">
                        <h3>What are Cookies?</h3>
                        <p>
                            Cookies are small text files stored on your device when you visit a website. They help improve your browsing experience by remembering your preferences and providing anonymized tracking data.
                        </p>
                    </section>

                    {/* How We Use Cookies Section */}
                    <section className="cards">
                        <h3>How We Use Cookies</h3>
                        <p>
                            We use cookies to enhance security, facilitate authentication, analyze usage patterns, and improve the overall functionality of our services. Some cookies are necessary for the website to function properly, while others are used for analytics and customization.
                        </p>
                    </section>

                    {/* Types of Cookies We Use */}
                    <section className="cards">
                        <h3>Types of Cookies We Use</h3>
                        <ul>
                            <li>
                                <strong>Essential Cookies:</strong> Necessary for the website to function and cannot be disabled.
                            </li>
                            <li>
                                <strong>Performance Cookies:</strong> Help us understand how visitors interact with our website.
                            </li>
                            <li>
                                <strong>Security Cookies:</strong> Used to enhance authentication and prevent fraudulent activity.
                            </li>
                            <li>
                                <strong>Functional Cookies:</strong> Store user preferences to provide a more personalized experience.
                            </li>
                        </ul>
                    </section>

                    {/* List of Cookies We Use */}
                    <section className="cards">
                        <h3>List of Cookies We Use</h3>
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Cookie Name</th>
                                    <th>Usage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>ACCOUNT_CHOOSER</td><td>Manages account selection for login authentication.</td></tr>
                                <tr><td>AEC</td><td>Ensures security and prevents fraudulent activity.</td></tr>
                                <tr><td>APISID</td><td>Used for user authentication and security.</td></tr>
                                <tr><td>HSID</td><td>Contains encrypted user authentication data.</td></tr>
                                <tr><td>LSID</td><td>Manages session login across Google services.</td></tr>
                                <tr><td>LSOLH</td><td>Stores login session-related data.</td></tr>
                                <tr><td>NID</td><td>Used for advertising and tracking user preferences.</td></tr>
                                <tr><td>OTZ</td><td>Stores aggregated analysis and site performance metrics.</td></tr>
                                <tr><td>SAPISID</td><td>Helps with user authentication and profile personalization.</td></tr>
                                <tr><td>SEARCH_SAMESITE</td><td>Helps enforce same-site security policies.</td></tr>
                                <tr><td>SID</td><td>Maintains user login and session security.</td></tr>
                                <tr><td>SIDCC</td><td>Provides security and authentication verification.</td></tr>
                                <tr><td>SMSV</td><td>Used for authentication security and session management.</td></tr>
                                <tr><td>SSID</td><td>Stores encrypted session and authentication details.</td></tr>
                                <tr><td>__Host-1PLSID</td><td>Session management across Google services.</td></tr>
                                <tr><td>__Host-3PLSID</td><td>Multi-service authentication and security.</td></tr>
                                <tr><td>__Host-GAPS</td><td>Authentication across Google domains.</td></tr>
                                <tr><td>__Secure-1PAPISID</td><td>Personalization and security enhancements.</td></tr>
                                <tr><td>__Secure-1PSID</td><td>User authentication and session security.</td></tr>
                                <tr><td>__Secure-1PSIDCC</td><td>Additional security measures for user sessions.</td></tr>
                                <tr><td>__Secure-1PSIDTS</td><td>Security tracking for session authentication.</td></tr>
                                <tr><td>__Secure-3PAPISID</td><td>Helps deliver targeted advertising.</td></tr>
                                <tr><td>__Secure-3PSID</td><td>Used for ad personalization and authentication.</td></tr>
                                <tr><td>__Secure-3PSIDCC</td><td>Stores user security preferences.</td></tr>
                                <tr><td>__Secure-3PSIDTS</td><td>Provides additional security tracking.</td></tr>
                                <tr><td>g_state</td><td>Likely used for session management and state tracking.</td></tr>
                            </tbody>
                        </table>
                    </section>

                    {/* Managing Cookie Preferences */}
                    <section className="cards">
                        <h3>Managing Your Cookie Preferences</h3>
                        <p>
                            You can manage your cookie preferences by adjusting your browser settings. Most browsers allow you to refuse or delete cookies, though this may impact your ability to use certain features of our platform.
                        </p>
                    </section>

                    {/* Changes to this Policy */}
                    <section className="cards">
                        <h3>Changes to this Policy</h3>
                        <p>
                            We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
                        </p>
                    </section>

                    {/* Contact Us Section */}
                    <section className="cards">
                        <h3>Contact Us</h3>
                        <p>
                            If you have any questions about this Cookie Policy, you can contact us at 
                            <a href="mailto:support.cd@caditsolutions.com"> support.cd@caditsolutions.com</a>.
                        </p>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CookiePolicy;
